const apiRoutes = {
  auth: {
    register: "/Auth/Register",
    login: "/Auth/Login",
    refresh: "/Auth/Refresh",
    logout: "/user/account/logout",
    sso: "/Auth/SSO",
    verify: "/Auth/Verify",
    resend: "/Auth/Verify/Resend",
    guest: "/Auth/Login/Guest",
  },
  profile: {
    account: "/User",
    authorize: "/User/2FA",
    uploads: "/user/account/uploads",
    password: "/User/Password",
    getUserBets: `/User/Bets`,
  },
  races: {
    list: "/Races",
    get: (id) => `/Races/${id}`,
    racerOdds: (id) => `/Races/RacerOdds/${id}`,
    random: "/Races/Random",
    getToken: (id) => `/Races/${id}/Token`,
  },
  racer: {
    details: (id) => `/Racers/Wins/${id}`,
  },
  community: {
    list: "/Blogs",
    get: (id) => `/Blogs/${id}`,
  },
  wallet: {
    connect_wallet: "/Wallet",
    topup: "/Wallet/Topup",
    remove: (id) => `/Wallet/${id}`,
    withdraw: "/Wallet/Withdraw",
  },

  bets: {
    place: "/Bet",
    getBets: (id) => `/Bet/${id}`,
    getUserBets: (id) => `/Bet/UserBets/${id}`,
  },
  support: {
    list: "/support",
    sub_list: (id) => `/support/${id}`,
  },
};

export default apiRoutes;
